import { render, staticRenderFns } from "./links.vue?vue&type=template&id=534a49ac&scoped=true"
import script from "./links.vue?vue&type=script&lang=js"
export * from "./links.vue?vue&type=script&lang=js"
import style0 from "./links.vue?vue&type=style&index=0&id=534a49ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a49ac",
  null
  
)

export default component.exports